import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {
  AlertController, LoadingController,
  ModalController, PopoverController
} from "@ionic/angular";
import {
  SmallAlertPage
} from "../../components/common/small-alert/small-alert.page";
import {
  AlertPage
} from "../../components/common/alert/alert.page";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class ViewService {

  // Oggetto con tutte le icone necessarie con chiave es {'succ': 'assets/img/icons/...'} valorizzato in inizialize
  static iconsMap: any = {};
  static isMobile: boolean;
  menuVisible: boolean;

  pipeChanged: number = 0;



  // VIGO
  currentPath: string;


  // I don't like this here
  topbar = {
    currentPath: "routes-history",
  };

  loading: any;

  // events

  static updateView = new Subject<any>();
  static updateView$ = ViewService.updateView.asObservable();




  constructor(
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private popoverController: PopoverController,
    private translate: TranslateService
  ) {}

  /** Mostra l'alert "Aggiornamento richiesto" con due bottoni impilati:
   *  "Controlla aggiornamenti" (apre lo store se checkUpdatesFn è passato) e
   *  "Apri nel web" che esegue openWebFallbackFn. */
  async showNativePageFallbackAlert(openWebFallbackFn: () => void, checkUpdatesFn?: () => void) {
    const buttons: any[] = [
      {
        label: this.translate.instant('NATIVE_PAGE_FALLBACK.controlla_aggiornamenti'),
        fill: 'outline',
        color: 'mid-light_base',
        click: checkUpdatesFn
      },
      {
        label: this.translate.instant('NATIVE_PAGE_FALLBACK.apri_web'),
        click: openWebFallbackFn
      }
    ];
    return this.modalAlert(
      this.translate.instant('NATIVE_PAGE_FALLBACK.titolo'),
      this.translate.instant('NATIVE_PAGE_FALLBACK.messaggio'),
      'warn',
      buttons,
      false,
      true
    );
  }

  /**
   * Avviso per una pagina non inclusa nella demo pubblica. Sul mobile non ci
   * sono route guard (a differenza del desktop, dove il messaggio lo mostra
   * IsLoggedGuard), quindi lo mostrano le pagine stesse al posto del redirect
   * al login, che dalla demo sembrerebbe uno sloggamento.
   */
  alertNonDisponibileInDemo(){
    return this.modalAlert(
      this.translate.instant('DEMO.non_disponibile_titolo'),
      this.translate.instant('DEMO.non_disponibile_messaggio'),
      'warn',
      'Ok'
    );
  }

  initialize(iconsMap: any, isMobile?: boolean){
    ViewService.iconsMap = iconsMap;
    ViewService.isMobile = isMobile;
  }



  /**
   * VIGO
   * @param path
   */
  setCurrentPath(path: string){
    this.currentPath = path;
    ViewService.updateView.next('currentPath');
  }

  async presentAlert(header: string, message: string, buttons: any[], subHeader?: string, cssClass?: string, backdropDismiss?: boolean, inputs?: any[]) {
    const alert = await this.alertController.create({
      cssClass: cssClass,
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: buttons,
      inputs: inputs,
      backdropDismiss: backdropDismiss
    });
    await alert.present();
  }

  // Crea un alert grafico. L'icona è presa da iconsMap e deve essere passato nel metodo initialize
  async modalAlert(title?: string, msg?: string, icon?: string, buttons?: any, disable_backdrop_dismiss?: boolean, stackButtons?: boolean ) {
    if(buttons){
      if(!Array.isArray(buttons)){
        buttons = [{label: buttons}];
      }
    }
    if(!icon) icon = 'info';
    const modal: HTMLIonModalElement = await this.modalCtrl.create({
      component: ViewService.isMobile ? SmallAlertPage : AlertPage,
      componentProps: {
        msg: msg,
        title: title,
        buttons: buttons,
        view: ViewService,
        hideCloseButton: disable_backdrop_dismiss,
        stackButtons: !!stackButtons
      },
      backdropDismiss: !disable_backdrop_dismiss,
      cssClass: "modal_alert",
    });
    modal.componentProps.icon = ViewService.iconsMap[icon] || '';
    await modal.present();
    return modal;
  }

  async showLoading(message?: any){
    if(this.loading && this.loading.isOverlay) this.loading.dismiss();
    this.loading = await this.loadingCtrl.create({
      message: message
    });
    await this.loading.present();
  }

  async hideLoading(){
    if(this.loading) await this.loading.dismiss();
  }

  async presentPopover(ev: any, component: any, componentProps?: any) {
    if(!component) return;
    const popover = await this.popoverController.create({
      component: component,
      event: ev,
      translucent: true,
      componentProps: componentProps
    });
    await popover.present();
    return popover;
  }


}
